import { render, staticRenderFns } from "./AttentionInfoIncidents.vue?vue&type=template&id=475174fa&scoped=true&lang=pug"
import script from "./AttentionInfoIncidents.vue?vue&type=script&lang=js"
export * from "./AttentionInfoIncidents.vue?vue&type=script&lang=js"
import style0 from "./AttentionInfoIncidents.vue?vue&type=style&index=0&id=475174fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475174fa",
  null
  
)

export default component.exports